export default {
  
    obra: {
    }
}